<template>
  <div class="test-box">
    <h1 class="testTitle">仙尊大人，恭喜您測試成功</h1>
    <p class="ma dl">
      您的神劍禮品碼為：
      <input type="text" :value="testMa" class="inputbox" />
    </p>
  </div>
</template>

<script>
export default {
  name: "SuccessgBox",
  props: ["testMa"],
  data() {
    return {};
  },
  created() {},
};
</script>

<style lang="less" scoped>
.test-box {
  font-family: medium;
  .testTitle {
    font-size: 0.3rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  .ma {
    font-size: 0.25rem;
    margin-bottom: 0.2rem;
    justify-content: center;
    .inputbox {
      width: 1.5rem;
      padding: 0.15rem 0.2rem;
      color: #000;
      background: url("../assets/images/inputbg.png");
      background-size: 100% 100%;
      border: none;
      text-align: left;
      font-weight: bold;
      font-size: 0.2rem;
    }
  }
}
</style>